import { toggleArrValue } from "utils/functions";
import Tooltip from "components/Tooltip";
import "./options.css";

export default function Options({
   name,
   value,
   error,
   label,
   max,
   style,
   extra_classes,
   disabled,
   multiple,
   options,
   onChange
}) {

   const onItemChange = ( item_value ) => {
      if ( !onChange ) return;

      if ( multiple ) {
         if ( max && ( value.length === max ) && !value.includes( item_value )) return;
         onChange( name, toggleArrValue( item_value, value || []))
      } else onChange( name, item_value );
   } 

   return (
      <div className={ "options " + ( extra_classes || "" )} style={ style }>
         { label && <div className="options-label"> { label } </div> }

         <div 
            className="options-items"
            role={multiple ? "group" : "radiogroup"}
            aria-label={label || undefined}
         > 
            { options && options.map(( item ) => {
               
               const is_active = multiple 
                  ? value?.includes( item.value )
                  : item.value === value;
               
               const is_item_disabled = item.disabled || disabled;

               return (
                  <div 
                     key={ item.value }
                     className={ `${is_active ? "active" : ""} ${is_item_disabled ? "disabled" : ""}` }
                     role={multiple ? "checkbox" : "radio"}
                     aria-checked={is_active}
                     aria-disabled={is_item_disabled}
                     tabIndex={is_item_disabled ? -1 : 0}
                     onClick={() => !is_item_disabled && onItemChange( item.value )}
                     onKeyDown={(e) => {
                        if (!is_item_disabled && (e.key === 'Enter' || e.key === ' ')) {
                           e.preventDefault();
                           onItemChange( item.value );
                        }
                     }}
                  >
                     { item.label }

                     { item.tooltip &&
                        <Tooltip text={ item.tooltip }/>
                     }
                  </div>
               )
            })}
         </div>

         { error && <div className="error"> { error } </div> }
      </div>
   )
}